module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_scotland_200px.d10ab561.png";